import React from 'react';
import { Typography } from '@material-ui/core';
import { Warning } from '@material-ui/icons';
import { styled } from '@material-ui/styles';
import { colors } from '../../../../../../healtheraComponents';

interface Props {
  isFormDirty: boolean;
}

const QuestionnaireHeader = ({ isFormDirty }: Props) => {
  if (!isFormDirty) {
    return <Typography variant="h5">Questionnaire</Typography>;
  }

  return (
    <StyledContainer>
      <Typography variant="h5">Questionnaire – </Typography>
      <Typography variant="h5">has unsaved changes </Typography>
      <StyledWarning />
    </StyledContainer>
  );
};

const StyledWarning = styled(Warning)({
  color: colors.HEALTHERA_RED
});

const StyledContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export default QuestionnaireHeader;
